import { Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ResourceTypes } from '../_enums/resourceTypes';
import { LifecycleFormComponent } from '../forms/lifecycle-form/lifecycle-form.component';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private isModalOpen = new BehaviorSubject<boolean>(false);
  private currentName = new BehaviorSubject<string | null>(null);
  private currentForm = new BehaviorSubject<{
    formRef: Type<any>;
    isTeam?: boolean;
  } | null>(null);

  private editForm = new BehaviorSubject<
    | {
        formRef: Type<any>;
        displayName: string;
        primaryOwner: string;
        secondaryOwner: string | null;
        id: string;
        resourceType: ResourceTypes;
        isGroupConnected: boolean;
        connectedGroupId: string;
      }
    | undefined
  >(undefined);

  private lifecycleForm = new BehaviorSubject<
    | {
        formRef: Type<LifecycleFormComponent>;
        displayName: string;
        endOfLife: string;
        id: string;
        resourceType: ResourceTypes;
        isGroupConnected: boolean;
        connectedGroupId: string;
      }
    | undefined
  >(undefined);

  private deleteForm = new BehaviorSubject<
    | {
        formRef: Type<any>;
        displayName: string;
        id: string;
        resourceType: ResourceTypes;
        isGroupConnected: boolean;
        connectedGroupId: string;
      }
    | undefined
  >(undefined);

  private currentLabel = new BehaviorSubject<string | null>(null);

  isModalOpen$ = this.isModalOpen.asObservable();
  currentForm$ = this.currentForm.asObservable();
  editForm$ = this.editForm.asObservable();
  lifecycleForm$ = this.lifecycleForm.asObservable();
  deleteForm$ = this.deleteForm.asObservable();
  currentLabel$ = this.currentLabel.asObservable();

  constructor() {}

  toggleModal(
    label: string,
    formData: { formRef: any; isTeam?: boolean },
  ): void {
    this.isModalOpen.next(!this.isModalOpen.value);
    if (formData) {
      this.currentForm.next(formData);
    }
    this.currentLabel.next(label);
  }

  toggleEditResourceModal(
    label: string,
    formData: {
      formRef: any;
      displayName: string;
      primaryOwner: string;
      secondaryOwner: string | null;
      id: string;
      resourceType: ResourceTypes;
      isGroupConnected: boolean;
      connectedGroupId: string;
    },
  ): void {
    this.isModalOpen.next(!this.isModalOpen.value);
    if (formData) {
      this.currentForm.next(formData);
      this.editForm.next(formData);
    }
    this.currentLabel.next(label);
  }

  toggleLifecycleModal(
    label: string,
    formData: {
      formRef: any;
      displayName: string;
      endOfLife: string;
      id: string;
      resourceType: ResourceTypes;
      isGroupConnected: boolean;
      connectedGroupId: string;
    },
  ): void {
    this.isModalOpen.next(!this.isModalOpen.value);
    if (formData) {
      this.currentForm.next(formData);
      this.lifecycleForm.next(formData);
    }
    this.currentLabel.next(label);
  }

  toggleDeleteResourceModal(
    label: string,
    formData: {
      formRef: any;
      displayName: string;
      id: string;
      resourceType: ResourceTypes;
      isGroupConnected: boolean;
      connectedGroupId: string;
    },
  ): void {
    this.isModalOpen.next(!this.isModalOpen.value);
    if (formData) {
      this.currentForm.next(formData);
      this.deleteForm.next(formData);
    }
    this.currentLabel.next(label);
  }

  resetModal(): void {
    this.isModalOpen.next(!this.isModalOpen.value);
    this.currentName.next(null);
    this.currentForm.next(null);
  }

  closeModal(): void {
    this.isModalOpen.next(false);
  }
}
